import { render } from "./OrderPartTableWrapper.vue?vue&type=template&id=e9c14158"
import script from "./OrderPartTableWrapper.vue?vue&type=script&lang=js"
export * from "./OrderPartTableWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__